/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-16 10:52:49
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-09 12:57:49
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/Components/HomepageSEOSetting/index.tsx
 */
/**
 *  Seo Setting
 *  Author: Luke
 *  CreatedAt: 2021-03-04
 */
import React from 'react';

import css from './css.less';

import ItemWrapper from '@/src/constrains/SalesChannelPreviewPageComponents/OverwriteItemWrapper';

import CountWords from '@/src/components/CountWords/CountWords';
import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';
import { Input, TextArea } from 'src/components/Antd';
import { Uploader } from 'src/components/Upload';

import _ from 'lodash';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const HomePageSEOSetting = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    title,
    description,
    favicon,
    onTitleChange,
    onDescriptionChange,
    onFavChange,
    isPrimary,
  } = props;

  const [fileList, setFileList] = React.useState(favicon ? [favicon] : []);
  React.useEffect(() => {
    if ((favicon || {}).uuid) setFileList([favicon]);
  }, [(favicon || {}).uuid]);

  return (
    <div className={css.container}>
      <Section>
        <ItemWrapper
          title={getI18n('general.customer.title')}
          rightPart={
            <CountWords count={(title || '').length} allCount={100} />
          }>
          <Input
            value={title}
            onChange={onTitleChange}
            size='large'
            placeholder={`${getI18n('general.customer.title')} (0/100)`}
            maxLength={100}
          />
        </ItemWrapper>
        <ItemWrapper
          rightPart={
            <CountWords count={(description || '').length} allCount={500} />
          }
          title={getI18n('salesChannelContent.index.homepageMetaDescription')}>
          <TextArea
            value={description}
            onChange={onDescriptionChange}
            maxLength={500}
            placeholder={`${getI18n(
              'salesChannelContent.index.homepageMetaDescription',
            )} (0/500)`}
          />
        </ItemWrapper>
        {isPrimary && (
          <ItemWrapper
            title={`${getI18n(
              'salesChannelContent.index.favicon',
            )} (196px * 196px)`}>
            <div className={css.favContainer}>
              <Uploader
                height={180}
                multiple={false}
                fileList={fileList}
                onChange={(imgArr = []) => {
                  setFileList(imgArr);
                  if (onFavChange) {
                    const _l = _.last(imgArr);

                    onFavChange(_l);
                  }
                }}
              />
            </div>
          </ItemWrapper>
        )}
      </Section>
    </div>
  );
};
export default HomePageSEOSetting;
